// extracted by mini-css-extract-plugin
export default {"box":"PdfField_box__prX3T","preview":"PdfField_preview__7-BV1","sizeTitle":"PdfField_sizeTitle__SOZ6r","uploadBtn":"PdfField_uploadBtn__Mh9I0","btn":"PdfField_btn__zbNdY"};